import { AlertTriangle, HardDrive, Volume2 } from 'lucide-react';
import type { AudioEngineSnapshot, AudioOutputMode } from '../../types/audio';

interface StatusBarProps {
  snapshot: AudioEngineSnapshot;
  onOutputMode: (mode: AudioOutputMode) => void;
  onMasterVolume: (volume: number) => void;
  message: string | null;
}

export function StatusBar({ snapshot, onOutputMode, onMasterVolume, message }: StatusBarProps) {
  return (
    <footer className="grid shrink-0 gap-3 border-t border-white/8 bg-[#0c1118] px-4 py-3 text-xs sm:grid-cols-[1fr_auto_1fr] sm:items-center lg:px-6">
      <div className="flex items-center gap-3">
        <Volume2 size={16} className="text-slate-400" />
        <span className="hidden text-slate-500 md:inline">Master</span>
        <input
          className="master-slider"
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={snapshot.masterVolume}
          onChange={(event) => onMasterVolume(Number(event.target.value))}
          aria-label="Volumen general"
        />
        <span className="w-8 font-mono text-slate-400">
          {Math.round(snapshot.masterVolume * 100)}
        </span>
      </div>
      <div className="output-switch" role="group" aria-label="Modo de salida">
        <button
          type="button"
          className={snapshot.outputMode === 'stereo' ? 'active' : ''}
          onClick={() => onOutputMode('stereo')}
        >
          Estéreo
        </button>
        <button
          type="button"
          className={snapshot.outputMode === 'music-click' ? 'active' : ''}
          onClick={() => onOutputMode('music-click')}
        >
          Música / Clic
        </button>
      </div>
      <div className="flex items-center justify-start gap-2 overflow-hidden text-slate-500 sm:justify-end">
        {message ? (
          <span className="flex min-w-0 items-center gap-1.5 text-amber-300">
            <AlertTriangle size={14} className="shrink-0" />
            <span className="truncate">{message}</span>
          </span>
        ) : snapshot.outputMode === 'music-click' ? (
          <span className="flex items-center gap-1.5 text-amber-400">
            <AlertTriangle size={14} /> L: música · R: clic/guía
          </span>
        ) : (
          <span className="flex items-center gap-1.5">
            <HardDrive size={14} />{' '}
            {snapshot.status === 'loading'
              ? 'Cargando audio…'
              : `${formatMegabytes(snapshot.memoryBytes)} MB en memoria`}
          </span>
        )}
      </div>
    </footer>
  );
}

function formatMegabytes(bytes: number): string {
  return bytes ? (bytes / 1024 / 1024).toFixed(0) : 'Sin audio';
}
